import { RootState } from "store";

export const selectDispensaries  = (state:RootState) => state.locations.dispensaries;